import { Type } from '@angular/core';

/**
 * Telas do próprio portal que podem ser abertas dentro do painel da tela de
 * funcionalidades, sem iframe: a chave é a rota do menu (`target`) e o valor
 * carrega o componente sob demanda.
 *
 * Menu cuja rota não estiver aqui continua navegando pelo router, como antes.
 * Para embutir uma tela nova, basta acrescentar uma linha nesta lista.
 */
export const COMPONENTES_INTERNOS: Record<string, () => Promise<Type<unknown>>> = {
  menus: () =>
    import('../../features/cadastro-menus/cadastro-menus.component').then(
      (m) => m.CadastroMenusComponent,
    ),
  'configurar-menu': () =>
    import('../../features/cadastro-menus/configurar-menu/configurar-menu.component').then(
      (m) => m.ConfigurarMenuComponent,
    ),
  usuarios: () =>
    import('../../features/manutencao-usuarios/manutencao-usuarios.component').then(
      (m) => m.ManutencaoUsuariosComponent,
    ),
  'cadastro-usuario': () =>
    import('../../features/manutencao-usuarios/cadastro-usuario/cadastro-usuario.component').then(
      (m) => m.CadastroUsuarioComponent,
    ),
  'detalhe-usuario': () =>
    import('../../features/manutencao-usuarios/detalhe-usuario/detalhe-usuario.component').then(
      (m) => m.DetalheUsuarioComponent,
    ),
};
